import React from 'react';
import { Link } from 'react-router-dom';
import ButtonAction from '../../Buttons/ButtonAction';
import './About.scss';
import * as ROUTES from '../../../routes';

function About(props) {
  return (
    <section className="About" id="about">
      <div className="about-wrapper">
        <div className="AboutDescription">
          <img src="./img/Landing/heroLayer/logo.svg" alt="logo" />
          <p className="AboutTitle">
            La plataforma digital de los abogados en México
          </p>
          <p className="AboutSubTitle normal_text">
            Somos la plataforma en donde se reúnen los mejores profesionales en
            la materia para brindar servicios legales a un mayor número de
            personas y empresas que lo necesitan.
          </p>
          <Link to={ROUTES.LANDING_PAGE_300}>
            <ButtonAction variant="extra">¡Regístrate!</ButtonAction>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default About;
